import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as xml2js from 'xml2js';
import { environment } from '../../../environments/environment';

export class NewsItem {
  date: string;
  title: string;
  formattedTitle: string;
  description: string;
  link: string;
  publisher: string;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  PROXY = environment.proxy_herokuapp;
  CORS_MODE: RequestMode = environment.cors_mode as RequestMode;
  newsSubject$ = new Subject();
  resetSubject$ = new Subject();
  newsItems: NewsItem[] = [];

  getNews(symbol: string) {
    const RSS_URL = `https://feeds.finance.yahoo.com/rss/2.0/headline?s=${symbol}&region=US&lang=en-US`;
    const headers = { 'Access-Control-Allow-Origin': '*' };
    return fetch(this.PROXY + RSS_URL)
      // return fetch(this.PROXY + RSS_URL)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.text();
      })
      .then(data => {
        return this.parseRSS(data);
      })
      .then(parsed => {
        this.newsSubject$.next(parsed);
      })
      .catch(error => {
        this.newsSubject$.next(`No news found.`);
      });
  }

  parseRSS(data) {
    return new Promise(resolve => {
      const arr = [];
      const parser = new xml2js.Parser(
        {
          trim: true,
          explicitArray: true
        });
      parser.parseString(data, (err, result) => {
        if (err) {
          return console.error('error parsing rss', err);
        }
        const items = result.rss.channel[0].item;
        items.forEach(item => {
          const newsItem = new NewsItem();
          newsItem.link = item.link[0];
          newsItem.date = item.pubDate[0];
          newsItem.title = item.title[0];
          newsItem.description = item.description[0];
          arr.push(newsItem);
        });
        resolve(arr);
      });
    });
  }
}
